// Generated from svc_call_city_zone_list_illinois_slim.csv.
// Keys are normalized city/place names; values are SVC-Call zone letters.
export const SVC_CALL_CITY_ZONES = {
  "abingdon": "H",
  "adair": "H",
  "adams": "I",
  "addieville": "I",
  "addison": "B",
  "adeline": "E",
  "albany": "G",
  "albers": "I",
  "albion": "I",
  "alden": "D",
  "aledo": "H",
  "alexander": "I",
  "alexis": "H",
  "algonquin": "D",
  "alhambra": "I",
  "allendale": "I",
  "allenville": "I",
  "allerton": "H",
  "alma": "I",
  "alpha": "H",
  "alsey": "I",
  "alsip": "F",
  "altamont": "I",
  "alto pass": "I",
  "alton": "I",
  "altona": "H",
  "alvan alvin": "H",
  "amboy": "E",
  "anchor": "G",
  "andalusia": "H",
  "andover": "H",
  "andres": "C",
  "anna": "I",
  "annapolis": "I",
  "annawan": "G",
  "antioch": "D",
  "apple canyon lake": "G",
  "apple river": "G",
  "arbury hills": "C",
  "arcola": "H",
  "arenzville": "I",
  "argenta": "H",
  "argyle": "D",
  "arlington": "E",
  "arlington heights": "D",
  "armington": "H",
  "aroma park": "E",
  "arrowsmith": "G",
  "arthur": "H",
  "ashkum": "E",
  "ashland": "I",
  "ashley": "I",
  "ashmore": "I",
  "ashton": "D",
  "assumption": "I",
  "astoria": "H",
  "athens": "H",
  "atkinson": "G",
  "atlanta": "H",
  "atwood": "H",
  "auburn": "I",
  "augusta": "I",
  "aurora": "A",
  "ava": "I",
  "aviston": "I",
  "avon": "H",
  "baileyville": "G",
  "baldwin": "I",
  "banner": "H",
  "bannockburn": "E",
  "bardolph": "H",
  "barrington": "D",
  "barrington hills": "B",
  "barry": "I",
  "barstow": "H",
  "bartelso": "I",
  "bartlett": "B",
  "bartonville": "H",
  "basco": "I",
  "batavia": "A",
  "batchtown": "I",
  "bath": "H",
  "bay view gardens": "G",
  "baylis": "I",
  "beach park": "E",
  "beardstown": "I",
  "beason": "H",
  "beaverville": "E",
  "beckemeyer": "I",
  "bedford park": "F",
  "beecher": "D",
  "beecher city": "I",
  "belgium": "H",
  "belknap": "I",
  "belle prairie city": "I",
  "belle rive": "I",
  "belleville": "I",
  "bellevue": "G",
  "bellflower": "G",
  "bellmont": "I",
  "bellwood": "C",
  "belvidere": "G",
  "bement": "H",
  "benld": "I",
  "bensenville": "C",
  "benson": "G",
  "bentley": "I",
  "benton": "I",
  "berkeley": "C",
  "berlin": "I",
  "berwyn": "F",
  "bethalto": "I",
  "bethany": "H",
  "beverly": "I",
  "big foot prairie": "D",
  "big rock": "A",
  "biggsville": "H",
  "bingham": "I",
  "bishop hill": "G",
  "bismarck": "H",
  "blairsville": "I",
  "blandinsville": "I",
  "bloomfield": "I",
  "bloomingdale": "B",
  "bloomington": "H",
  "blue island": "E",
  "blue mound": "H",
  "bluffs": "I",
  "bluford": "I",
  "bolingbrook": "B",
  "bondville": "H",
  "bone gap": "I",
  "bonfield": "D",
  "bonnie": "I",
  "bonnie brae": "B",
  "boody": "H",
  "boulder hill": "B",
  "bourbonnais": "G",
  "bowen": "I",
  "braceville": "D",
  "bradford": "G",
  "bradley": "G",
  "braidwood": "D",
  "breese": "I",
  "bridgeport": "I",
  "bridgeview": "F",
  "brighton": "I",
  "brimfield": "H",
  "broadlands": "H",
  "broadview": "C",
  "broadwell": "H",
  "brocton": "H",
  "brookfield": "C",
  "brooklyn": "I",
  "brookport": "I",
  "broughton": "I",
  "browning": "I",
  "browns": "I",
  "brownstown": "I",
  "brussels": "I",
  "bryant": "H",
  "buckingham": "E",
  "buckley": "G",
  "buckner": "I",
  "buda": "G",
  "buffalo": "H",
  "buffalo grove": "D",
  "buffalo prairie": "H",
  "bull valley": "C",
  "bulpitt": "I",
  "buncombe": "I",
  "bunker hill": "I",
  "burbank": "F",
  "bureau junction": "E",
  "burlington": "B",
  "burnham": "D",
  "burnt prairie": "I",
  "burr ridge": "C",
  "burton": "I",
  "burtons bridge": "C",
  "bush": "I",
  "bushnell": "H",
  "butler": "I",
  "byron": "E",
  "cabery": "E",
  "cable": "H",
  "cahokia heights": "I",
  "cairo": "I",
  "caledonia": "D",
  "calhoun": "I",
  "calumet city": "E",
  "calumet park": "F",
  "camargo": "H",
  "cambria": "I",
  "cambridge": "G",
  "camden": "I",
  "cameron": "H",
  "camp point": "I",
  "campbell hill": "I",
  "campbell s island": "H",
  "campton hills": "B",
  "campus": "E",
  "candlewick lake": "D",
  "canton": "H",
  "cantrall": "H",
  "capron": "D",
  "carbon cliff": "H",
  "carbon hill": "C",
  "carbondale": "I",
  "carlinville": "I",
  "carlock": "G",
  "carlyle": "I",
  "carman": "I",
  "carmi": "I",
  "carol stream": "B",
  "carpentersville": "D",
  "carrier mills": "I",
  "carrollton": "I",
  "carterville": "I",
  "carthage": "I",
  "cary": "C",
  "casey": "I",
  "caseyville": "I",
  "catlin": "H",
  "cave in rock": "I",
  "cedar point": "E",
  "cedarville": "G",
  "central city": "I",
  "centralia": "I",
  "cerro gordo": "H",
  "chadwick": "G",
  "champaign": "H",
  "chandlerville": "I",
  "channahon": "D",
  "channel lake": "D",
  "chapin": "I",
  "charleston": "H",
  "chatham": "I",
  "chatsworth": "G",
  "chebanse": "E",
  "chemung": "D",
  "chenoa": "G",
  "cherry": "E",
  "cherry valley": "D",
  "chester": "I",
  "chesterfield": "I",
  "chestnut": "H",
  "chicago": "F",
  "chicago heights": "D",
  "chicago ridge": "F",
  "chillicothe": "G",
  "chrisman": "H",
  "christopher": "I",
  "cicero": "F",
  "cisco": "H",
  "cisne": "I",
  "cissna park": "G",
  "claremont": "I",
  "clarendon hills": "C",
  "clay city": "I",
  "clayton": "I",
  "cleveland": "H",
  "clifton": "E",
  "clinton": "H",
  "coal city": "D",
  "coal valley": "H",
  "coalton": "I",
  "coatsburg": "I",
  "cobden": "I",
  "coffeen": "I",
  "colchester": "I",
  "coleta": "G",
  "colfax": "G",
  "collinsville": "I",
  "colona": "H",
  "colp": "I",
  "columbia": "I",
  "columbus": "I",
  "como": "G",
  "compton": "D",
  "concord": "I",
  "congerville": "G",
  "cooksville": "G",
  "coral": "C",
  "cordova": "G",
  "cornell": "E",
  "cornland": "H",
  "cortland": "B",
  "coulterville": "I",
  "country club hills": "E",
  "countryside": "C",
  "cowden": "I",
  "coyne center": "H",
  "crab orchard": "I",
  "crainville": "I",
  "creal springs": "I",
  "crescent city": "G",
  "crest hill": "D",
  "creston": "C",
  "crestwood": "F",
  "crete": "E",
  "creve coeur": "H",
  "crossville": "I",
  "crystal lake": "D",
  "crystal lawns": "B",
  "cuba": "H",
  "cullom": "E",
  "curran": "I",
  "custer park": "D",
  "cutler": "I",
  "cypress": "I",
  "dahlgren": "I",
  "dakota": "G",
  "dallas city": "I",
  "dalton city": "H",
  "dalzell": "E",
  "damiansville": "I",
  "dana": "E",
  "danforth": "G",
  "danvers": "G",
  "danville": "H",
  "darien": "B",
  "darmstadt": "I",
  "davis": "G",
  "davis junction": "D",
  "dawson": "H",
  "dayton": "D",
  "de land": "H",
  "de pue": "E",
  "de soto": "I",
  "de witt": "H",
  "decatur": "H",
  "deer creek": "G",
  "deer grove": "G",
  "deer park": "B",
  "deerfield": "E",
  "dekalb": "G",
  "delavan": "H",
  "des plaines": "D",
  "detroit": "I",
  "dewey": "G",
  "diamond": "C",
  "dieterich": "I",
  "divernon": "I",
  "dix": "I",
  "dixmoor": "E",
  "dixon": "G",
  "dolton": "E",
  "dongola": "I",
  "donnellson": "I",
  "donovan": "G",
  "dorchester": "I",
  "dover": "E",
  "dowell": "I",
  "downers grove": "B",
  "downs": "G",
  "du bois": "I",
  "du quoin": "I",
  "dundas": "I",
  "dunfermline": "H",
  "dunlap": "G",
  "dupo": "I",
  "durand": "E",
  "dwight": "G",
  "eagarville": "I",
  "eagle lake": "D",
  "earlville": "C",
  "east alton": "I",
  "east brooklyn": "D",
  "east cape girardeau": "I",
  "east carondelet": "I",
  "east dubuque": "H",
  "east dundee": "D",
  "east galesburg": "H",
  "east gillespie": "I",
  "east hazel crest": "C",
  "east lynn": "G",
  "east moline": "H",
  "east peoria": "H",
  "east st louis": "I",
  "easton": "H",
  "eddyville": "I",
  "edgewood": "I",
  "edgington": "H",
  "edinburg": "I",
  "edwardsville": "I",
  "effingham": "I",
  "el dara": "I",
  "el paso": "G",
  "elburn": "B",
  "eldorado": "I",
  "eldred": "I",
  "elgin": "B",
  "eliza": "H",
  "elizabeth": "G",
  "elizabethtown": "I",
  "elk grove village": "D",
  "elkhart": "H",
  "elkville": "I",
  "elliott": "G",
  "ellis grove": "I",
  "ellisville": "H",
  "ellsworth": "G",
  "elmhurst": "C",
  "elmwood": "H",
  "elmwood park": "B",
  "elsah": "I",
  "elvaston": "I",
  "elwin": "H",
  "elwood": "C",
  "emden": "H",
  "emington": "E",
  "energy": "I",
  "enfield": "I",
  "equality": "I",
  "erie": "G",
  "essex": "D",
  "eureka": "G",
  "evanston": "E",
  "evansville": "I",
  "evergreen park": "F",
  "ewing": "I",
  "exeter": "I",
  "fairbury": "G",
  "fairfield": "I",
  "fairmont": "B",
  "fairmont city": "I",
  "fairmount": "H",
  "fairview": "H",
  "fairview heights": "I",
  "fall creek": "I",
  "farina": "I",
  "farmer city": "H",
  "farmersville": "I",
  "farmington": "H",
  "fayetteville": "I",
  "ferris": "I",
  "fidelity": "I",
  "fieldon": "I",
  "fillmore": "I",
  "findlay": "I",
  "fisher": "G",
  "fithian": "H",
  "flanagan": "G",
  "flat rock": "I",
  "flora": "I",
  "floraville": "I",
  "florence": "I",
  "flossmoor": "E",
  "foosland": "G",
  "ford heights": "D",
  "forest city": "H",
  "forest lake": "C",
  "forest park": "F",
  "forest view": "F",
  "forrest": "G",
  "forreston": "G",
  "forsyth": "H",
  "fowler": "I",
  "fox lake": "D",
  "fox lake hills": "D",
  "fox river grove": "B",
  "frankfort": "D",
  "frankfort square": "C",
  "franklin": "I",
  "franklin grove": "D",
  "franklin park": "C",
  "franklinville": "C",
  "freeburg": "I",
  "freeman spur": "I",
  "freeport": "G",
  "fulton": "G",
  "fults": "I",
  "gages lake": "D",
  "galatia": "I",
  "galena": "H",
  "galesburg": "H",
  "galt": "G",
  "galva": "G",
  "garden prairie": "C",
  "gardner": "D",
  "garrett": "H",
  "gays": "I",
  "geneseo": "G",
  "geneva": "A",
  "genoa": "C",
  "georgetown": "H",
  "german valley": "E",
  "germantown": "I",
  "germantown hills": "G",
  "gibson city": "G",
  "gifford": "G",
  "gilberts": "D",
  "gillespie": "I",
  "gilman": "G",
  "gilson": "H",
  "girard": "I",
  "gladstone": "H",
  "glasford": "H",
  "glasgow": "I",
  "glen carbon": "I",
  "glen ellyn": "A",
  "glencoe": "E",
  "glendale heights": "B",
  "glenview": "E",
  "glenwood": "D",
  "godfrey": "I",
  "godley": "D",
  "golconda": "I",
  "golden": "I",
  "golden gate": "I",
  "golf": "E",
  "good hope": "H",
  "goodenow": "D",
  "goodfield": "G",
  "goofy ridge": "H",
  "goreville": "I",
  "gorham": "I",
  "grafton": "I",
  "grand detour": "E",
  "grand ridge": "D",
  "grand tower": "I",
  "grandview": "H",
  "grandwood park": "D",
  "granite city": "I",
  "grant park": "E",
  "grantfork": "I",
  "granville": "E",
  "grayslake": "D",
  "grayville": "I",
  "green oaks": "E",
  "green valley": "H",
  "greenfield": "I",
  "greenup": "I",
  "greenview": "H",
  "greenville": "I",
  "greenwood": "D",
  "gridley": "G",
  "griggsville": "I",
  "gulfport": "I",
  "gurnee": "D",
  "hainesville": "D",
  "hamburg": "I",
  "hamel": "I",
  "hamilton": "I",
  "hamlet": "H",
  "hammond": "H",
  "hampshire": "D",
  "hampton": "H",
  "hanaford": "I",
  "hanna city": "H",
  "hanover": "H",
  "hanover park": "B",
  "hardin": "I",
  "harding": "C",
  "harmon": "E",
  "harmony": "B",
  "harrisburg": "I",
  "harrison": "I",
  "harristown": "H",
  "hartford": "I",
  "hartland": "D",
  "hartsburg": "H",
  "harvard": "G",
  "harvel": "I",
  "harvey": "E",
  "harwood heights": "E",
  "havana": "H",
  "hawthorn woods": "C",
  "hazel crest": "E",
  "hebron": "D",
  "hecker": "I",
  "henderson": "H",
  "hennepin": "E",
  "henning": "H",
  "henry": "G",
  "heritage lake": "G",
  "herrick": "I",
  "herrin": "I",
  "herscher": "E",
  "hettick": "I",
  "heyworth": "H",
  "hickory hills": "B",
  "hidalgo": "I",
  "highland": "I",
  "highland park": "E",
  "highwood": "E",
  "hillcrest": "D",
  "hillsboro": "I",
  "hillsdale": "G",
  "hillside": "C",
  "hillview": "I",
  "hinckley": "B",
  "hindsboro": "H",
  "hinsdale": "C",
  "hodgkins": "B",
  "hoffman": "I",
  "hoffman estates": "D",
  "holcomb": "D",
  "holiday hills": "C",
  "holiday shores": "I",
  "hollowayville": "E",
  "homer": "H",
  "homer glen": "C",
  "hometown": "F",
  "homewood": "E",
  "hoopeston": "H",
  "hooppole": "G",
  "hopedale": "H",
  "hopewell": "G",
  "hopkins park": "E",
  "hoyleton": "I",
  "hudson": "G",
  "huey": "I",
  "hull": "I",
  "humboldt": "H",
  "hume": "H",
  "huntley": "D",
  "hurst": "I",
  "hutsonville": "I",
  "illinois city": "H",
  "illiopolis": "H",
  "ina": "I",
  "indian creek": "C",
  "indian head park": "C",
  "indianola": "H",
  "industry": "I",
  "ingalls park": "B",
  "inverness": "D",
  "iola": "I",
  "ipava": "H",
  "iroquois": "G",
  "irving": "I",
  "irvington": "I",
  "irwin": "E",
  "island lake": "C",
  "itasca": "B",
  "iuka": "I",
  "ivesdale": "H",
  "jacksonville": "I",
  "janesville": "I",
  "jeffersonville": "I",
  "jeisyville": "I",
  "jerome": "I",
  "jerseyville": "I",
  "jewett": "I",
  "johnsburg": "D",
  "johnsonville": "I",
  "johnston city": "I",
  "joliet": "D",
  "jonesboro": "I",
  "joppa": "I",
  "joslin": "G",
  "joy": "H",
  "junction": "I",
  "junction city": "I",
  "justice": "C",
  "kampsville": "I",
  "kane": "I",
  "kaneville": "A",
  "kangley": "E",
  "kankakee": "G",
  "kansas": "I",
  "kappa": "G",
  "karnak": "I",
  "kaskaskia": "I",
  "keenes": "I",
  "keensburg": "I",
  "keithsburg": "H",
  "kell": "I",
  "kempton": "E",
  "kenilworth": "E",
  "kenney": "H",
  "kewanee": "G",
  "keyesport": "I",
  "kilbourne": "H",
  "kildeer": "C",
  "kincaid": "I",
  "kinderhook": "I",
  "kings": "D",
  "kingston": "I",
  "kingston mines": "H",
  "kinmundy": "I",
  "kinsman": "D",
  "kirkland": "C",
  "kirkwood": "H",
  "knollwood": "E",
  "knoxville": "H",
  "la clede": "I",
  "la fayette": "G",
  "la grange": "C",
  "la grange park": "C",
  "la harpe": "I",
  "la moille": "E",
  "la prairie": "I",
  "la rose": "G",
  "lacon": "G",
  "ladd": "E",
  "lake barrington": "C",
  "lake bluff": "E",
  "lake camelot": "H",
  "lake carroll": "G",
  "lake catherine": "D",
  "lake city": "H",
  "lake forest": "E",
  "lake holiday": "B",
  "lake in the hills": "D",
  "lake ka ho": "I",
  "lake of the woods": "H",
  "lake petersburg": "H",
  "lake summerset": "G",
  "lake villa": "D",
  "lake zurich": "D",
  "lakemoor": "C",
  "lakewood": "I",
  "lakewood shores": "C",
  "lanark": "G",
  "lane": "H",
  "langleyville": "I",
  "lansing": "E",
  "laplace": "H",
  "lasalle": "G",
  "latham": "H",
  "lawrence": "D",
  "lawrenceville": "I",
  "le roy": "G",
  "leaf river": "E",
  "lebanon": "I",
  "lee": "C",
  "lee center": "D",
  "leland": "C",
  "leland grove": "I",
  "lemont": "C",
  "lena": "G",
  "lenzburg": "I",
  "leonore": "E",
  "lerna": "I",
  "lewistown": "H",
  "lexington": "G",
  "liberty": "I",
  "libertyville": "D",
  "lily lake": "A",
  "lima": "I",
  "limestone": "D",
  "lincoln": "H",
  "lincolnshire": "D",
  "lincolnwood": "F",
  "lindenhurst": "D",
  "lisbon": "B",
  "lisle": "A",
  "litchfield": "I",
  "literberry": "I",
  "little york": "H",
  "littleton": "I",
  "liverpool": "H",
  "livingston": "I",
  "loami": "I",
  "lockport": "C",
  "lockport heights": "B",
  "loda": "G",
  "lomax": "I",
  "lombard": "B",
  "london mills": "H",
  "long creek": "H",
  "long grove": "D",
  "long lake": "D",
  "long point": "E",
  "longview": "H",
  "loraine": "I",
  "lorenzo": "C",
  "lost nation": "E",
  "lostant": "E",
  "louisville": "I",
  "loves park": "D",
  "lovington": "H",
  "lowpoint": "G",
  "ludlow": "G",
  "lyndon": "G",
  "lynn center": "H",
  "lynnville": "I",
  "lynwood": "D",
  "lyons": "F",
  "macedonia": "I",
  "machesney park": "E",
  "mackinaw": "G",
  "macomb": "H",
  "macon": "H",
  "madison": "I",
  "maeystown": "I",
  "magnolia": "E",
  "mahomet": "H",
  "makanda": "I",
  "malden": "E",
  "malta": "C",
  "manchester": "I",
  "manhattan": "D",
  "manito": "H",
  "manlius": "G",
  "mansfield": "H",
  "manteno": "D",
  "maple park": "B",
  "mapleton": "H",
  "maquon": "H",
  "marcelline": "I",
  "marengo": "G",
  "marietta": "H",
  "marine": "I",
  "marion": "I",
  "marissa": "I",
  "mark": "E",
  "markham": "E",
  "marley": "B",
  "maroa": "H",
  "marquette heights": "H",
  "marseilles": "D",
  "marshall": "I",
  "martinsville": "I",
  "martinton": "G",
  "maryville": "I",
  "mascoutah": "I",
  "mason": "I",
  "mason city": "H",
  "matherville": "H",
  "matteson": "E",
  "mattoon": "H",
  "maunie": "I",
  "maywood": "C",
  "mazon": "D",
  "mcclure": "I",
  "mccook": "B",
  "mccullom lake": "D",
  "mchenry": "D",
  "mclean": "H",
  "mcleansboro": "I",
  "mcnabb": "E",
  "mechanicsburg": "H",
  "media": "H",
  "medora": "I",
  "melrose park": "C",
  "melvin": "G",
  "mendon": "I",
  "mendota": "G",
  "menominee": "H",
  "meredosia": "I",
  "merrionette park": "F",
  "merritt": "I",
  "metamora": "G",
  "metcalf": "H",
  "metropolis": "I",
  "mettawa": "E",
  "meyer": "I",
  "middletown": "H",
  "midlothian": "F",
  "milan": "H",
  "milford": "G",
  "mill creek": "I",
  "mill shoals": "I",
  "millbrook": "B",
  "milledgeville": "G",
  "millersburg": "H",
  "millington": "B",
  "millstadt": "I",
  "milton": "I",
  "mineral": "G",
  "minier": "H",
  "minonk": "G",
  "minooka": "D",
  "mitchell": "I",
  "modesto": "I",
  "mokena": "D",
  "moline": "H",
  "momence": "E",
  "monee": "G",
  "monmouth": "H",
  "monroe center": "D",
  "montgomery": "A",
  "monticello": "H",
  "montrose": "I",
  "moro": "I",
  "morris": "G",
  "morrison": "G",
  "morrisonville": "I",
  "morton": "G",
  "morton grove": "E",
  "mossville": "G",
  "mound city": "I",
  "mound station": "I",
  "mounds": "I",
  "mount auburn": "H",
  "mount carmel": "I",
  "mount carroll": "G",
  "mount clare": "I",
  "mount erie": "I",
  "mount morris": "E",
  "mount olive": "I",
  "mount prospect": "D",
  "mount pulaski": "H",
  "mount sterling": "I",
  "mount vernon": "I",
  "mount zion": "H",
  "moweaqua": "I",
  "muddy": "I",
  "mulberry grove": "I",
  "mulkeytown": "I",
  "muncie": "H",
  "mundelein": "D",
  "murphysboro": "I",
  "murrayville": "I",
  "nachusa": "E",
  "naperville": "A",
  "naplate": "D",
  "naples": "I",
  "nashville": "I",
  "nason": "I",
  "nauvoo": "I",
  "nebo": "I",
  "nekoma": "H",
  "nelson": "E",
  "neoga": "I",
  "neponset": "G",
  "new athens": "I",
  "new baden": "I",
  "new bedford": "G",
  "new berlin": "I",
  "new boston": "H",
  "new burnside": "I",
  "new canton": "I",
  "new douglas": "I",
  "new grand chain": "I",
  "new haven": "I",
  "new holland": "H",
  "new lenox": "D",
  "new milford": "D",
  "new minden": "I",
  "new salem": "I",
  "newark": "B",
  "newman": "H",
  "newton": "I",
  "niantic": "H",
  "niles": "E",
  "nilwood": "I",
  "niota": "I",
  "noble": "I",
  "nokomis": "I",
  "nora": "G",
  "normal": "H",
  "norridge": "E",
  "norris": "H",
  "norris city": "I",
  "north aurora": "A",
  "north barrington": "C",
  "north chicago": "E",
  "north city": "I",
  "north henderson": "H",
  "north pekin": "H",
  "north riverside": "C",
  "north utica": "D",
  "northbrook": "E",
  "northfield": "E",
  "northlake": "C",
  "norwood": "G",
  "o fallon": "I",
  "oak brook": "C",
  "oak forest": "F",
  "oak grove": "H",
  "oak lawn": "F",
  "oak park": "F",
  "oak run": "H",
  "oakbrook terrace": "B",
  "oakdale": "I",
  "oakford": "H",
  "oakland": "H",
  "oakwood": "H",
  "oakwood hills": "C",
  "oblong": "I",
  "oconee": "I",
  "odell": "E",
  "odin": "I",
  "ogden": "H",
  "oglesby": "E",
  "ohio": "E",
  "ohlman": "I",
  "okawville": "I",
  "old mill creek": "D",
  "old ripley": "I",
  "old shawneetown": "I",
  "olive branch": "I",
  "olivet": "H",
  "olmsted": "I",
  "olney": "I",
  "olympia fields": "C",
  "omaha": "I",
  "onarga": "G",
  "oneida": "H",
  "opdyke": "I",
  "ophiem": "H",
  "oquawka": "H",
  "orangeville": "G",
  "oreana": "H",
  "oregon": "E",
  "orient": "I",
  "orion": "H",
  "orland hills": "C",
  "orland park": "C",
  "osco": "H",
  "oswego": "B",
  "ottawa": "G",
  "otterville": "I",
  "owaneco": "I",
  "oxville": "I",
  "paderborn": "I",
  "palatine": "D",
  "palestine": "I",
  "palmer": "I",
  "palmyra": "I",
  "paloma": "I",
  "palos heights": "C",
  "palos hills": "C",
  "palos park": "C",
  "pana": "I",
  "panama": "I",
  "panola": "G",
  "papineau": "E",
  "paris": "I",
  "park city": "E",
  "park forest": "E",
  "park ridge": "E",
  "parkersburg": "I",
  "patoka": "I",
  "paw paw": "C",
  "pawnee": "I",
  "paxton": "G",
  "payson": "I",
  "pearl": "I",
  "pearl city": "G",
  "pecatonica": "E",
  "pekin": "H",
  "penfield": "H",
  "peoria": "H",
  "peoria heights": "G",
  "peotone": "E",
  "percy": "I",
  "perry": "I",
  "peru": "G",
  "pesotum": "H",
  "petersburg": "H",
  "phillipstown": "I",
  "philo": "H",
  "phoenix": "F",
  "pierron": "I",
  "pinckneyville": "I",
  "pingree grove": "D",
  "piper city": "G",
  "pistakee highlands": "D",
  "pittsburg": "I",
  "pittsfield": "I",
  "plainfield": "B",
  "plainville": "I",
  "plano": "B",
  "plattville": "B",
  "pleasant hill": "I",
  "pleasant plains": "I",
  "plum valley": "D",
  "plymouth": "I",
  "pocahontas": "I",
  "polo": "E",
  "pontiac": "G",
  "pontoon beach": "I",
  "pontoosuc": "I",
  "poplar grove": "D",
  "port barrington": "C",
  "port byron": "H",
  "posen": "F",
  "potomac": "H",
  "prairie city": "H",
  "prairie du rocher": "I",
  "prairie grove": "C",
  "prairietown": "I",
  "preemption": "H",
  "prestbury": "A",
  "preston heights": "B",
  "princeton": "E",
  "princeville": "G",
  "prophetstown": "G",
  "prospect heights": "D",
  "pulaski": "I",
  "quincy": "I",
  "radom": "I",
  "raleigh": "I",
  "ramsey": "I",
  "rankin": "G",
  "ransom": "D",
  "rantoul": "H",
  "rapids city": "H",
  "raritan": "H",
  "raymond": "I",
  "red bud": "I",
  "reddick": "D",
  "redmon": "H",
  "rentchler": "I",
  "rest haven": "D",
  "reynolds": "H",
  "richfield": "I",
  "richmond": "D",
  "richton park": "E",
  "richview": "I",
  "ridge farm": "H",
  "ridgefield": "C",
  "ridgewood": "B",
  "ridgway": "I",
  "ridott": "G",
  "riggston": "I",
  "riley": "C",
  "ringwood": "D",
  "rio": "H",
  "ripley": "I",
  "ritchie": "D",
  "river forest": "F",
  "river grove": "B",
  "riverdale": "E",
  "riverside": "C",
  "riverton": "H",
  "riverwoods": "E",
  "roanoke": "G",
  "robbins": "F",
  "roberts": "G",
  "robinson": "I",
  "rochelle": "G",
  "rochester": "I",
  "rock city": "G",
  "rock falls": "G",
  "rock island": "H",
  "rock island arsenal": "H",
  "rockbridge": "I",
  "rockdale": "D",
  "rockford": "G",
  "rockport": "I",
  "rockton": "E",
  "rockwood": "I",
  "rolling meadows": "D",
  "rome": "G",
  "romeoville": "B",
  "roodhouse": "I",
  "roscoe": "E",
  "rose hill": "I",
  "roselle": "B",
  "rosemont": "B",
  "roseville": "H",
  "rosewood heights": "I",
  "rosiclare": "I",
  "rossville": "G",
  "round lake": "D",
  "round lake beach": "D",
  "round lake heights": "D",
  "round lake park": "D",
  "roxana": "I",
  "royal": "H",
  "royal lakes": "I",
  "royalton": "I",
  "ruma": "I",
  "rushville": "I",
  "russellville": "I",
  "rutland": "G",
  "sadorus": "H",
  "sailor springs": "I",
  "salem": "I",
  "sammons point": "E",
  "san jose": "H",
  "sandoval": "I",
  "sandwich": "B",
  "sauget": "I",
  "sauk village": "D",
  "saunemin": "E",
  "savanna": "G",
  "savoy": "H",
  "sawyerville": "I",
  "saybrook": "G",
  "scales mound": "H",
  "schaumburg": "D",
  "schiller park": "B",
  "schram city": "I",
  "sciota": "H",
  "scott afb": "I",
  "scottville": "I",
  "seaton": "H",
  "seatonville": "E",
  "secor": "G",
  "seneca": "D",
  "serena": "C",
  "sesser": "I",
  "seymour": "H",
  "shabbona": "C",
  "shannon": "G",
  "shawneetown": "I",
  "sheffield": "G",
  "shelbyville": "I",
  "sheldon": "G",
  "sheridan": "B",
  "sherman": "H",
  "sherrard": "H",
  "shiloh": "I",
  "shipman": "I",
  "shirley": "G",
  "shorewood": "B",
  "shumway": "I",
  "sibley": "G",
  "sidell": "H",
  "sidney": "H",
  "sigel": "I",
  "silvis": "H",
  "simpson": "I",
  "sims": "I",
  "skokie": "E",
  "sleepy hollow": "D",
  "smithboro": "I",
  "smithfield": "H",
  "smithton": "I",
  "smithville": "H",
  "solon mills": "D",
  "somonauk": "B",
  "sorento": "I",
  "south barrington": "B",
  "south beloit": "E",
  "south chicago heights": "D",
  "south elgin": "B",
  "south holland": "E",
  "south jacksonville": "I",
  "south pekin": "H",
  "south roxana": "I",
  "south wilmington": "D",
  "southern view": "I",
  "sparland": "G",
  "sparta": "I",
  "spaulding": "H",
  "spillertown": "I",
  "spring bay": "G",
  "spring grove": "D",
  "spring valley": "E",
  "springerton": "I",
  "springfield": "I",
  "st anne": "E",
  "st augustine": "H",
  "st charles": "A",
  "st david": "H",
  "st elmo": "I",
  "st francisville": "I",
  "st jacob": "I",
  "st johns": "I",
  "st joseph": "H",
  "st libory": "I",
  "st peter": "I",
  "st rose": "I",
  "standard": "E",
  "standard city": "I",
  "stanford": "H",
  "staunton": "I",
  "ste marie": "I",
  "steeleville": "I",
  "steger": "E",
  "sterling": "G",
  "steward": "C",
  "stewardson": "I",
  "stickney": "F",
  "stillman valley": "D",
  "stockton": "G",
  "stone park": "B",
  "stonefort": "I",
  "stonington": "I",
  "stoy": "I",
  "strasburg": "I",
  "strawn": "G",
  "streamwood": "B",
  "streator": "G",
  "stronghurst": "H",
  "sublette": "D",
  "sugar grove": "A",
  "sullivan": "H",
  "summerfield": "I",
  "summit": "F",
  "sumner": "I",
  "sun river terrace": "E",
  "sunnyland": "B",
  "swansea": "I",
  "swedona": "H",
  "sycamore": "G",
  "symerton": "C",
  "table grove": "H",
  "tallula": "H",
  "tamaroa": "I",
  "tamms": "I",
  "tampico": "G",
  "taylor ridge": "H",
  "taylor springs": "I",
  "taylorville": "I",
  "tennessee": "I",
  "teutopolis": "I",
  "thawville": "G",
  "thayer": "I",
  "the galena territory": "H",
  "thebes": "I",
  "third lake": "D",
  "thomasboro": "H",
  "thompsonville": "I",
  "thomson": "G",
  "thornton": "D",
  "tilden": "I",
  "tilton": "H",
  "timberlane": "D",
  "tinley park": "E",
  "tiskilwa": "G",
  "toledo": "I",
  "tolono": "H",
  "toluca": "G",
  "tonica": "E",
  "topeka": "H",
  "toulon": "G",
  "tovey": "I",
  "towanda": "G",
  "tower hill": "I",
  "tower lakes": "C",
  "tremont": "H",
  "trenton": "I",
  "trilla": "I",
  "triumph": "D",
  "trivoli": "H",
  "trout valley": "B",
  "troy": "I",
  "troy grove": "D",
  "tuscola": "H",
  "twin grove": "G",
  "ullin": "I",
  "union": "C",
  "union hill": "D",
  "unity": "I",
  "university park": "D",
  "urbana": "H",
  "ursa": "I",
  "valier": "I",
  "valley city": "I",
  "valmeyer": "I",
  "vandalia": "I",
  "varna": "G",
  "venedy": "I",
  "venetian village": "D",
  "venice": "I",
  "vergennes": "I",
  "vermilion": "I",
  "vermont": "H",
  "vernon": "I",
  "vernon hills": "D",
  "verona": "D",
  "versailles": "I",
  "victoria": "H",
  "vienna": "I",
  "villa grove": "H",
  "villa park": "B",
  "viola": "H",
  "virden": "I",
  "virgil": "B",
  "virginia": "I",
  "volo": "C",
  "wadsworth": "E",
  "waggoner": "I",
  "walnut": "G",
  "walnut hill": "I",
  "walshville": "I",
  "waltonville": "I",
  "wamac": "I",
  "wapella": "H",
  "warren": "G",
  "warrensburg": "H",
  "warrenville": "A",
  "warsaw": "I",
  "washburn": "G",
  "washington": "G",
  "washington park": "I",
  "wataga": "H",
  "waterloo": "I",
  "waterman": "B",
  "watseka": "G",
  "watson": "I",
  "wauconda": "C",
  "waukegan": "E",
  "waverly": "I",
  "wayne": "B",
  "wayne city": "I",
  "waynesville": "H",
  "wedron": "C",
  "weldon": "H",
  "wellington": "G",
  "wenona": "E",
  "wenonah": "I",
  "west brooklyn": "D",
  "west chicago": "A",
  "west city": "I",
  "west dundee": "D",
  "west frankfort": "I",
  "west liberty": "I",
  "west peoria": "G",
  "west point": "I",
  "west salem": "I",
  "west union": "I",
  "west york": "I",
  "westchester": "C",
  "western springs": "C",
  "westervelt": "I",
  "westfield": "I",
  "westlake village": "E",
  "westmont": "C",
  "westville": "H",
  "wheaton": "A",
  "wheeler": "I",
  "wheeling": "D",
  "white city": "I",
  "white hall": "I",
  "white heath": "H",
  "whiteash": "I",
  "williamsfield": "H",
  "williamson": "I",
  "williamsville": "H",
  "willisville": "I",
  "willow hill": "I",
  "willow lake": "G",
  "willow springs": "C",
  "willowbrook": "C",
  "wilmette": "E",
  "wilmington": "D",
  "wilsonville": "I",
  "wilton center": "C",
  "winchester": "I",
  "windsor": "I",
  "winfield": "A",
  "winnebago": "E",
  "winnetka": "E",
  "winslow": "G",
  "winthrop harbor": "E",
  "witt": "I",
  "wonder lake": "D",
  "wood dale": "B",
  "wood river": "I",
  "woodhull": "H",
  "woodland": "G",
  "woodlawn": "I",
  "woodridge": "B",
  "woodson": "I",
  "woodstock": "D",
  "worden": "I",
  "worth": "C",
  "wyanet": "G",
  "wyoming": "G",
  "xenia": "I",
  "yale": "I",
  "yates city": "H",
  "yorkville": "B",
  "zeigler": "I",
  "zion": "E"
};

export default SVC_CALL_CITY_ZONES;
